module.exports = __webpack_public_path__ + "static/media/about-me.ddb3185f.jpg";